import gql from 'graphql-tag';
import { OrderItem, ORDER_ITEM_FRAGMENT } from '../useOrder/order.rest';

export type ReturnItemRelationship = {
  __typename: 'RestReturnItemRelationship';
  id: string;
};

export type Return = {
  __typename: 'RestReturn';
  id: string;
  attributes: {
    __typename: 'RestReturnAttributes';
    createdAt: string;
    orderId: number;
    orderNumber: string;
    shipmentNumber: string;
    shipmentStatus: {
      __typename: 'RestReturnStatus';
      id: string;
      name: string;
    };
    shipmentType: string;
    returnMethod: number;
    shippingLabel: string;
  };
  relationships: {
    __typename: 'RestReturnRelationships';
    returnOrderItems: {
      __typename: 'RestReturnItems';
      data: ReturnItemRelationship[];
    };
  };
};

export type GetReturnQueryVariables = {
  shipmentNumber: string;
  countryCode: string;
};

export type GetReturnQuery = {
  getReturn: {
    __typename: 'RestReturnPayload';
    data: Return[];
    included: OrderItem[];
  };
};

export const RETURN_FRAGMENT = gql`
  fragment ReturnFragment on RestReturn {
    id
    attributes @type(name: "RestReturnAttributes") {
      createdAt: created_at
      orderId: order_id
      orderNumber: order_number
      shipmentNumber: shipment_number
      shipmentStatus: shipment_status @type(name: "RestReturnStatus") {
        id
        name
      }
      shipmentType: shipment_type
      returnMethod: return_method_display
      shippingLabel: shipping_label
    }
    relationships @type(name: "RestReturnRelationships") {
      returnOrderItems: return_order_items @type(name: "RestReturnItems") {
        data @type(name: "RestReturnItemRelationship") {
          id
        }
      }
    }
  }
`;

export const GET_RETURN_QUERY = gql`
  query GetReturnQuery($shipmentNumber: string!, $countryCode: String!) {
    getReturn(shipmentNumber: $shipmentNumber, countryCode: $countryCode)
    @rest(
      type: "RestReturnPayload"
      endpoint: "shipments"
      path: "/v3.5/shipments?shipment_number={args.shipmentNumber}&include=return_order_items&shipment_type=RETURN&country_code={args.countryCode}"
    ) {
      data @type(name: "RestReturn") {
        ...ReturnFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
    }
  }
  ${RETURN_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;
